import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  coupons: [],
  filteredCoupons: [],
  displayedCoupons: [],
  initialCouponData: {
    couponCode: '',
    discount: 0,
    discountType: '',
    minimumBillAmount: 0,
    maximumDiscountAmount: 0,
    couponPerUser: 1,
    validTill: '',
    rewardPoints: 0,
  },
  filters: {
    search: '',
  },
  pagination: {
    currentPage: 1,
    itemsPerPage: 10,
    totalItems: 0,
    totalPages: 1,
  },
  loading: false,
  error: null,
};

const couponSlice = createSlice({
  name: 'coupons',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setAllCoupons: (state, action) => {
      state.coupons = action.payload;
      applyFilters(state);
    },
    updateCouponData: (state, action) => {
      state.initialCouponData = {
        ...state.initialCouponData,
        ...action.payload,
      };
    },
    resetCouponData: (state) => {
      state.initialCouponData = initialState.initialCouponData;
    },
    setFilters: (state, action) => {
      state.filters = {
        ...state.filters,
        ...action.payload,
      };
      applyFilters(state);
    },
    setCurrentPage: (state, action) => {
      state.pagination.currentPage = action.payload;
      paginate(state);
    },
    setPagination: (state, action) => {
      state.pagination = {
        ...state.pagination,
        ...action.payload,
      };
      state.pagination.totalPages = Math.ceil(
        state.pagination.totalItems / state.pagination.itemsPerPage,
      );
      paginate(state);
    },
    resetFilters: (state) => {
      state.filters = initialState.filters;
      state.pagination.itemsPerPage = 10;
      applyFilters(state);
    },
  },
});

function applyFilters(state) {
  const { search } = state.filters;
  let result = [...state.coupons];

  if (search) {
    const lowerSearch = search.toLowerCase().replace(/\s/g, '');
    result = result.filter((item) => {
      const lowerCouponCode = item?.couponCode?.toLowerCase().replace(/\s/g, '');
      if (!lowerCouponCode) {
        return false;
      }

      let codeIndex = 0;
      let searchIndex = 0;
      while (codeIndex < lowerCouponCode.length && searchIndex < lowerSearch.length) {
        if (lowerCouponCode[codeIndex] === lowerSearch[searchIndex]) {
          searchIndex++;
        }
        codeIndex++;
      }
      return searchIndex === lowerSearch.length;
    });
  }

  state.filteredCoupons = result;
  state.pagination.totalItems = result.length;
  state.pagination.totalPages = Math.ceil(result.length / state.pagination.itemsPerPage) || 1;
  state.pagination.currentPage = 1;
  paginate(state);
}

function paginate(state) {
  const { currentPage, itemsPerPage } = state.pagination;
  const start = (currentPage - 1) * itemsPerPage;
  const end = start + itemsPerPage;
  state.displayedCoupons = state.filteredCoupons.slice(start, end);
}

export const {
  setLoading,
  setError,
  setAllCoupons,
  updateCouponData,
  resetCouponData,
  setFilters,
  setCurrentPage,
  setPagination,
  resetFilters,
} = couponSlice.actions;

export default couponSlice.reducer;
